/**
 * Bulk pivot CSV merge helpers.
 * Row shaping lives in pivot-table-engine.ts alongside the pivot table engine.
 */

import { type CsvExportField } from '@bbkShared/utils/export-file';

export {
  buildPivotTableExportRows,
  exportPivotTableToCsvString,
} from '@bbkAdminComponents/pivot-table/pivot-table-engine';

export const mergePivotExportRows = (
  exports: Array<{ fields: CsvExportField[]; rows: Record<string, unknown>[] }>,
  extraColumns: CsvExportField[] = []
): { fields: CsvExportField[]; rows: Record<string, unknown>[] } => {
  if (!exports.length) {
    return { fields: extraColumns, rows: [] };
  }

  const fields = [...extraColumns, ...exports[0]!.fields];
  const rows = exports.flatMap(({ rows }) => rows);

  return { fields, rows };
};
